import { Box, Card, Tab, Tabs, Typography } from "@mui/material";
import React from "react";
import JobsNotStarted from "../../components/HouseKeeping/JobsNotStarted";
import JobsNeedAttention from "../../components/HouseKeeping/JobsNeedAttention";
import DailyJobs from "../../components/HouseKeeping/DailyJobs";

const HouseKeepingScreen = () => {
  const [selectedTab, setSelectedTab] = React.useState("jobs-not-started");
  const handleTabChange = (_, newValue) => {
    setSelectedTab(newValue);
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "#e3f2fd",
          padding: 2,
          borderRadius: 1,
          mt: 3,
          mb: 2,
        }}
      >
        <Typography variant="h5" fontWeight="600" color="primary">
          Schedule Jobs House Keeping
        </Typography>
      </Box>
      <Card sx={{ p: 2, mt: 5 }}>
        <Tabs
          value={selectedTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
          sx={{ borderBottom: 1, borderColor: "divider" }}
        >
          <Tab label="Jobs Not Started" value="jobs-not-started" />
          <Tab label="Jobs Need Attention" value="jobs-need-attention" />
          <Tab label="Daily Jobs" value="daily-jobs" />
        </Tabs>

        {/* Tab Content */}
        <Box sx={{ mt: 2 }}>
          {selectedTab === "jobs-not-started" && (
            <JobsNotStarted></JobsNotStarted>
          )}
          {selectedTab === "jobs-need-attention" && <JobsNeedAttention />}
          {selectedTab === "daily-jobs" && <DailyJobs />}
        </Box>
      </Card>
    </>
  );
};

export default HouseKeepingScreen;
